/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST



export const getCustomerBatchTable = params => {
  return axios.post(`${base}/statistic_projectbatch`, params)
}
export const exportCustomerBatchLog = params => {
  return axios.post(`${base}/export_batch_log`, params)
}
export const getCustomerBatchDetail = params => {
  return axios.get(`${base}/batch_${params.id}`)
}
export const createCustomerBatchData = params => {
  return axios.post(`${base}/create_batch`, params)
}
export const updateCustomerBatchData = params => {
  return axios.post(`${base}/edit_batch_${params.id}`, params)
}
export const deleteCustomerBatchData = params => {
  return axios.post(`${base}/deleteCustomerBatchData/${params.id}`, params)
}
export const getCustomerBatchPeriodTable = params => {
  return axios.post(`${base}/statistic_projectbatch_period_${params.id}`, params)
}
export const queryCustomBatchTag = params => {
  return axios.post(`${base}/query_custom_batch_tag`, params)
}
export const createCustomBatchTag = params => {
  return axios.post(`${base}/create_custom_batch_tag`, params)
}
export const deleteCustomBatchTag = params => {
  return axios.post(`${base}/delete_custom_batch_tag_${params.id}`, params)
}
export const deleteBatchData = params => {
  return axios.post(`${base}/delete_batch_${params.id}`)
}
export const bindBatchTrainingInstruction = params => {
  return axios.post(`${base}/training_instruction/bind_batch_${params.id}`, params)
}

export const querySalaryIncreasingCityTable = params => {
  return axios.post(`${base}/incr_salary/city_list`, params)
}
export const querySalaryIncreasingTable = params => {
  return axios.post(`${base}/incr_salary/query`, params)
}
export const getSalaryIncreasingDetail = params => {
  return axios.get(`${base}/incr_salary/get_${params.id}`)
}
export const countSalaryIncreasingTask = params => {
  return axios.post(`${base}/incr_salary/count_task`, params)
}
export const predictSalaryIncreasingTaskCost = params => {
  return axios.post(`${base}/incr_salary/predict_cost`, params)
}
export const getProjectFrozenAmount = params => {
  return axios.post(`${base}/incr_salary/project_frozen_amount`, params)
}
export const AddSalaryIncreasing = params => {
  return axios.post(`${base}/incr_salary/create`, params)
}
export const editSalaryIncreasing = params => {
  return axios.post(`${base}/incr_salary/edit_${params.id}`, params)
}
export const deleteSalaryIncreasing = params => {
  return axios.post(`${base}/incr_salary/delete_${params.id}`, params)
}
export const startSalaryIncreasing = params => {
  return axios.post(`${base}/incr_salary/start_${params.id}`, params)
}
export const startSalaryIncreasingMultiple = params => {
  return axios.post(`${base}/incr_salary/start`, params)
}
export const restartSalaryIncreasing = params => {
  return axios.post(`${base}/incr_salary/restart_${params.id}`, params)
}
export const recoverySalaryIncreasing = params => {
  return axios.post(`${base}/incr_salary/recovery_${params.id}`, params)
}
export const querySalaryIncreasingLogTable = params => {
  return axios.post(`${base}/incr_salary/query_log`, params)
}
export const queryCityList = params => {
  return axios.post(`${base}/query_citylist`, params)
}
export const batchPersonnelRequirementAPI = params => {
  return axios.post(`${base}/batch_jobs/batch_sync_personnel_requirement_to_task`, params)
}






// WEBPACK FOOTER //
// ./src/views/customer-batch/customer-batch.api.js